module.exports = __webpack_public_path__ + "assets/images/50B-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/50B-route-sheet.png
// module id = 1300
// module chunks = 1